import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { GetWarehousesApiParameter } from "@insite/client-framework/Services/WarehouseService";
import applyChanges from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/ApplyChanges";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentShipToState, getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getWarehousesDataView } from "@insite/client-framework/Store/Data/Warehouses/WarehousesSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FindLocationModal from "@insite/content-library/Components/FindLocationModal";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import MapPin from "@insite/mobius/Icons/MapPin";
import Popover, { PopoverPresentationProps } from "@insite/mobius/Popover";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DeliveryTruckLine from "@store/Components/Icons/DeliveryTruckLine";
import StorePickupLine from "@store/Components/Icons/StorePickupLine";
import usePreviousExisting from "@store/Hooks/usePreviousExisting";
import LoadingOverlay, { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { getStoreSession } from "@store/Store/Context/ContextSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { fulfillmentMethodRadioWrapperBaseStyles, fulfillmentMethodRadioWrapperSelectedStyles, fulfillmentMethodRadioWrapperUnselectedStyles, fulfillmentMethodShape } from "@store/theme/common/mixins/fulfillmentMethod";
import { getLoadingOverlayProps } from "@store/theme/common/props/loadingOverlay";
import { COMMON, MENU, TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import Color from "color";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

const mapStateToProps = (state: StoreApplicationState) => {
    const session = getStoreSession(state);
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const warehousesParametersPageSize = 1000;

    const warehousesParameter: GetWarehousesApiParameter = {
        search: "",
        latitude: 0,
        longitude: 0,
        pageSize: warehousesParametersPageSize,
    };

    return {
        rememberMe: state.context.session.rememberMe,
        isSignedIn: state.context.session.userName && !getCurrentUserIsGuest(state),
        warehousesDataView: getWarehousesDataView(state, warehousesParameter),
        warehousesParameter,
        fulfillmentMethod: session.fulfillmentMethod,
        currentWarehouseName: session.pickUpWarehouse?.name,
        currentWarehouseDescription: session.pickUpWarehouse?.description,
        currentWarehouseAddress: `${session.pickUpWarehouse?.address1} ${session.pickUpWarehouse?.address2} ${session.pickUpWarehouse?.city} ${session.pickUpWarehouse?.state} ${session.pickUpWarehouse?.postalCode}`,
        currentBillTo: getCurrentBillToState(state).value,
        currentShipTo: getCurrentShipToState(state).value,
        shipToState: getShipToState(state, cart?.shipToId),
        addressesPageUrl: getPageLinkByPageType(state, "AddressesPage")?.url,
        pickUpWarehouse: state.context.session.pickUpWarehouse,
        warehousesParametersPageSize,
    };
};

const mapDispatchToProps = {
    loadWarehouses,
    applyChanges: makeHandlerChainAwaitable(applyChanges),
    changeCustomerContext,
};

export interface BranchIndicatorStyles {
    container?: InjectableCss;
    branchIndicatorWrapper?: InjectableCss;
    branchIndicatorHidden?: HiddenProps;
    branchIndicatorHiddenMobile?: HiddenProps;
    branchIndicatorIcon?: IconPresentationProps;
    branchIndicatorIconMobile?: IconPresentationProps;
    chevronIcon?: IconPresentationProps;
    chevronIconMobile?: IconPresentationProps;
    innerBranchIndicatorWrapper?: InjectableCss;
    salesCenterText?: TypographyProps;
    branchText?: TypographyProps;
    branchTextMobile?: TypographyProps;
    salesCenterTextMobile?: TypographyProps;
    popover?: PopoverPresentationProps;
    loadingOverlay?: LoadingOverlayProps;
    warehousesContainer?: GridContainerProps;
    popoverTitleGridItem?: GridItemProps;
    popoverTitle?: TypographyProps;
    fulfillmentMethodSelectionLabelGridItem?: GridItemProps;
    fulfillmentMethodSelectionLabel?: TypographyProps;
    fulfillmentMethodRadioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
    fulfillmentMethodRadio?: FieldSetPresentationProps<RadioComponentProps>;
    fulfillmentMethodWrapper?: InjectableCss;
    separatorWrapper?: InjectableCss;
    fulfillmentMethodRadioWrapper?: InjectableCss;
    fulfillmentMethodRadioWrapperSelected?: InjectableCss;
    fulfillmentMethodLabel?: TypographyProps;
    separatorLabel?: TypographyProps;
    pickupIcon?: IconPresentationProps;
    shippingIcon?: IconPresentationProps;
    selectedPickupIcon?: IconPresentationProps;
    selectedShippingIcon?: IconPresentationProps;
    addressSelectorGridItem?: GridItemProps;
    addressSelectorClickable?: ClickablePresentationProps;
    addressSelectorPickupIcon?: IconPresentationProps;
    addressSelectorShippingIcon?: IconPresentationProps;
    addressSelectorTextWrapper?: InjectableCss;
    addressSelectorTitleText?: TypographyProps;
    addressSelectorTasableLabel?: TypographyProps;
    addressSelectorAddressText?: TypographyProps;
    addressSelectorChevronIcon?: IconPresentationProps;
}

export const MOBILE_INDICATOR_HEIGHT = 40;

const fulfillmentMethodRadioWrapperStyles = css`
    ${fulfillmentMethodRadioWrapperBaseStyles(fulfillmentMethodShape.circle)}
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 61px;
    height: 61px;
`;

export const styles: BranchIndicatorStyles = {
    container: {
        css: css`
            display: inline-flex;
            height: 100%;
            margin: 0 0.5em;

            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        { values: [null, "0"], properties: ["margin"] },
                        { values: [null, Color(props.theme.colors.primary.main).string()], properties: ["background-color"] },
                        { values: [null, `${MOBILE_INDICATOR_HEIGHT}px`], properties: ["height"] },
                        { values: [null, "100%"], properties: ["width"] },
                        { values: [null, Color(props.theme.colors.primary.contrast).string()], properties: ["color"] },
                    ],
                    mediaOptions.max,
                )}

                ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        {
                            values: COMMON.spacing.side
                                .slice(0, 2)
                                .map(x => (x ? `calc(${x} - ${MENU.mobileButtonSpacing})` : x)),
                            properties: ["padding-right", "padding-left"],
                        },
                    ],
                    mediaOptions.minMax,
                )}
        `,
    },
    popover: {
        wrapperProps: {
            css: css`
                height: 100%;
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: ["static !important", null, null, "relative !important"], properties: ["position"] }], // Must be !important because it's not overridable
                        mediaOptions.min,
                    )}
            `,
        },
        contentBodyProps: {
            css: css`
                max-height: none;
                box-shadow: ${getProp("theme.shadows.main")};
                color: inherit;
                color: ${getColor("text")};
                margin-top: 1px;
            `,
        },
    },
    branchIndicatorWrapper: {
        css: css`
            color: ${getColor("header.contrastMain")};
            height: 100%;
            cursor: pointer;
            width: 100%;

                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            { values: [null, `0 ${MENU.mobileButtonSpacing}`], properties: ["padding"] },
                            { values: [null, "relative"], properties: ["positon"] },
                        ],
                        mediaOptions.max,
                    )}
        `,
    },
    branchIndicatorHidden: {
        css: css`
            display: flex;
            align-items: flex-end;
            justify-content: center;
        `,
    },
    branchIndicatorHiddenMobile: {
        css: css`
            display: flex;
            flex-direction: row;
            color: ${getColor("primary.contrast")};
            font-size: ${TYPOGRAPHY.size.smallest};
            align-items: center;
        `,
    },
    innerBranchIndicatorWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-right: 0.5em;
        `,
    },
    salesCenterText: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: ${TYPOGRAPHY.lineHeight.small};
            font-weight: ${TYPOGRAPHY.weight.bold};
            margin: 0.5em 0 0.25em;
            white-space: nowrap;

            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: [null, TYPOGRAPHY.weight.base], properties: ["font-weight"] }],
                    mediaOptions.max,
                )}
        `,
    },
    branchIndicatorIcon: {
        color: "primary",
        size: 14,
        src: MapPin,
        css: css`
            margin-right: 0.25em;
        `,
    },
    branchIndicatorIconMobile: {
        size: 18,
        src: MapPin,
        css: css`
            color: ${getColor("primary.contrast")};
            margin: 0 0.5em 0.2em 0;
        `,
    },
    branchText: {
        css: css`
            color: ${getColor("primary")};
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.bold};
            line-height: ${TYPOGRAPHY.lineHeight.small};
            max-width: 183px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        `,
    },
    chevronIcon: {
        color: "primary",
        size: 15,
        src: ChevronDown,
    },
    chevronIconMobile: {
        color: "primary.contrast",
        size: 15,
        src: ChevronDown,
        css: css`
            margin: 0.25em 0 0 0.5em;
        `,
    },
    salesCenterTextMobile: {
        css: css`
            text-wrap: nowrap;
            overflow: hidden;
            width: calc(100% - 30px);
            text-overflow: ellipsis;
            white-space: pre;
        `,
    },
    branchTextMobile: {
        as: "span",
        css: css`
            margin-left: 1em;
            color: ${getColor("primary.contrast")};
            font-weight: ${TYPOGRAPHY.weight.bold};
            white-space: pre;
        `,
    },
    loadingOverlay: getLoadingOverlayProps(),
    warehousesContainer: {
        gap: 0,
        css: css`
            padding: 20px;
        `,
    },
    popoverTitleGridItem: {
        width: 12,
        css: css`
            padding-bottom: 1.75em;
        `,
    },
    popoverTitle: {
        weight: TYPOGRAPHY.weight.black,
        size: TYPOGRAPHY.size.base,
    },
    fulfillmentMethodSelectionLabelGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    fulfillmentMethodSelectionLabel: {
        size: TYPOGRAPHY.size.small,
        weight: TYPOGRAPHY.weight.bold,
        css: css`
            color: ${getColor("text")};
            margin-bottom: .75em;
        `,
    },
    fulfillmentMethodRadioGroup: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: flex-start;
            position: relative;
            width: 100%;
            padding-bottom: 1em;
            margin-bottom: 1em;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    fulfillmentMethodWrapper: {
        css: css`
            display: flex;
            align-items: center;
            flex-direction: column;
        `,
    },
    separatorWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    fulfillmentMethodRadioWrapper: {
        css: css`
            ${fulfillmentMethodRadioWrapperStyles}
            ${fulfillmentMethodRadioWrapperUnselectedStyles}
            background-color: ${getColor("common.border")};
        `,
    },
    fulfillmentMethodRadioWrapperSelected: {
        css: css`
            ${fulfillmentMethodRadioWrapperStyles}
            ${fulfillmentMethodRadioWrapperSelectedStyles}
        `,
    },
    fulfillmentMethodRadio: {
        css: css`
            position: absolute;
            opacity: 0;
            top: -2px;
            left: -2px;

            & + ${IconWrapper} {
                cursor: pointer;
            }

            input {
                width: 62px;
                height: 62px;
                margin: 0;
                cursor: pointer;
            }

        `,
    },
    pickupIcon: {
        color: "primary.contrast",
        size: 30,
        src: StorePickupLine,
    },
    shippingIcon: {
        color: "primary.contrast",
        size: 30,
        src: DeliveryTruckLine,
    },
    selectedPickupIcon: {
        color: "primary",
        size: 30,
        src: StorePickupLine,
    },
    selectedShippingIcon: {
        color: "primary",
        size: 30,
        src: DeliveryTruckLine,
    },
    fulfillmentMethodLabel: {
        size: TYPOGRAPHY.size.small,
        weight: TYPOGRAPHY.weight.bold,
        css: css`
            color: ${getColor("text")};
            margin-top: 0.5em;
        `,
    },
    separatorLabel: {
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.bold,
        css: css`
            color: ${getColor("text")};
            margin: 1.5em 1em 0;
        `,
    },
    addressSelectorGridItem: {
        width: 12,
        css: css`
            justify-content: center;
        `,
    },
    addressSelectorClickable: {
        css: css`
            display: flex;
            flex-direction: row;
            width: 100%;
            max-width: 300px;
            border: 2px solid ${getColor("primary")};
            border-radius: 14px;
            padding: 0.75em;
            margin: .25em 0;
        `,
    },
    addressSelectorPickupIcon: {
        color: "primary",
        size: 18,
        src: StorePickupLine,
    },
    addressSelectorShippingIcon: {
        color: "primary",
        size: 18,
        src: DeliveryTruckLine,
    },
    addressSelectorTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin: 0 0.5em;
        `,
    },
    addressSelectorTitleText: {
        size: TYPOGRAPHY.size.smallest,
        weight: TYPOGRAPHY.weight.bold,
    },
    addressSelectorTasableLabel: {
        size: TYPOGRAPHY.size.tiny,
        weight: TYPOGRAPHY.weight.base,
        as: "span",
        css: css`
            margin-left: 1em;
            text-transform: uppercase;
        `,
    },
    addressSelectorAddressText: {
        size: TYPOGRAPHY.size.smallest,
    },
    addressSelectorChevronIcon: {
        color: "primary",
        size: 18,
        src: ChevronRight,
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const BranchIndicator: React.FunctionComponent<Props> = ({
    isSignedIn,
    currentWarehouseName,
    currentWarehouseDescription,
    currentWarehouseAddress,
    warehousesDataView,
    warehousesParameter,
    loadWarehouses,
    fulfillmentMethod,
    currentShipTo,
    shipToState,
    addressesPageUrl,
    currentBillTo,
    changeCustomerContext,
    pickUpWarehouse,
    warehousesParametersPageSize,
    history
}) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const isPickup = fulfillmentMethod === FulfillmentMethod.PickUp;
    const isShipping = fulfillmentMethod === FulfillmentMethod.Ship;

    React.useEffect(() => {
        loadWarehouses({ ...warehousesParameter, pageSize: warehousesParameter.pageSize ?? warehousesParametersPageSize });
    }, []);

    const warehouses = warehousesDataView.value;
    const prevBillTo = usePreviousExisting(currentBillTo) || currentBillTo;
    const prevShipTo = usePreviousExisting(currentShipTo);
    const displayedCurrentShipTo = shipToState.value || currentShipTo || prevShipTo;

    React.useEffect(() => {
        if (!currentBillTo || !warehousesDataView.value || !prevBillTo) {
            return;
        }

        if (currentBillTo.customerNumber !== prevBillTo.customerNumber) {
            handleWarehouseSelected(warehousesDataView.value[0]);
        }
    }, [currentBillTo]);

    const element = React.useRef<HTMLUListElement>(null);
    const popover = React.useRef<HTMLUListElement>(null);

    const handleWarehouseSelected = (warehouse: WarehouseModel) => {
        setIsLoading(true);
        const firstPickupAllowedWarehouse = warehousesDataView.value?.find(warehouse => warehouse.allowPickup);


        changeCustomerContext({
            fulfillmentMethod,
            pickUpWarehouse: !warehouse.allowPickup ? firstPickupAllowedWarehouse || warehouse : warehouse, 
            onSuccess: () => {
                setIsFindLocationOpen(false);
                setIsLoading(false);
            },
        });
    };

    const addressDisplay = () => {
        if (isPickup) {
            return `${translate("Pickup")} - ${currentWarehouseName} ${currentWarehouseDescription}`;
        }

        if (isShipping) {
            return `${translate("Shipping")} - ${displayedCurrentShipTo?.fullAddress || ""}`;
        }
    }

    const addressSelectorDisplay = (fulfillmentMethod: string) => {
        if (fulfillmentMethod === FulfillmentMethod.PickUp) {
            return `${translate("Pickup")} - ${currentWarehouseName} ${currentWarehouseDescription}`;
        }

        if (fulfillmentMethod === FulfillmentMethod.Ship) {
            return (
                <>
                    {translate("Shipping")} - {displayedCurrentShipTo?.customerNumber || displayedCurrentShipTo?.companyName || ""}
                    <Typography {...styles.addressSelectorTasableLabel}>{taxableLabelDisplay(displayedCurrentShipTo?.properties?.shipToTaxCode || "")}</Typography>
                </>
            );
        }
    }

    const taxableLabelDisplay = (taxCode: string) => {
        if (taxCode === "T") {
            return translate("Taxable");
        }

        if (taxCode === "NT") {
            return translate("Non-Taxable");
        }

        return null;
    };

    const fulfillmentMethodChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsLoading(true);
        changeCustomerContext({ fulfillmentMethod: event.currentTarget.value, pickUpWarehouse });
    };

    const [isFindLocationOpen, setIsFindLocationOpen] = React.useState(false);
    const handleOpenFindLocation = () => {
        setIsFindLocationOpen(true);
    };
    const handleFindLocationModalClose = () => setIsFindLocationOpen(false);

    const handleLinkToAddressPage = () => {
        history.replace(addressesPageUrl ?? '/');
    };

    const branchIndicator = (
        <Clickable {...styles.branchIndicatorWrapper}>
            <Hidden {...styles.branchIndicatorHidden} below="md">
                <StyledWrapper {...styles.innerBranchIndicatorWrapper}>
                    <Typography {...styles.salesCenterText}>
                        {translate("How do you want your items?")}
                    </Typography>
                    <Typography {...styles.branchText}>
                        <Icon {...styles.branchIndicatorIcon} />
                        {addressDisplay()}
                    </Typography>
                </StyledWrapper>
                <Icon {...styles.chevronIcon} />
            </Hidden>
            <Hidden {...styles.branchIndicatorHiddenMobile} above="sm">
                <Icon {...styles.branchIndicatorIconMobile} />
                <Typography {...styles.salesCenterTextMobile}>
                    {translate("How do you want your items?")}
                    <Typography {...styles.branchTextMobile}>{addressDisplay()}</Typography>
                </Typography>
                <Icon {...styles.chevronIconMobile} />
            </Hidden>
        </Clickable>
    );

    return (
        <>
            <StyledWrapper {...styles.container}>
                <Popover
                    {...styles.popover}
                    contentBodyProps={{
                        ...styles.popover?.contentBodyProps,
                        as: "div",
                        ref: element,
                        css: css`
                            ${styles.popover?.contentBodyProps?.css}
                            width: 100%;
                            left: 0;
                            ${props => {
                                if (isSignedIn) {
                                    return breakpointValuesMediaQueries(
                                        props.theme,
                                        [
                                            { values: [null, null, "320px"], properties: ["width"] },
                                            { values: [null, null, "0",], properties: ["left"] },
                                        ],
                                        mediaOptions.min,
                                    );
                                }

                                return breakpointValuesMediaQueries(
                                    props.theme,
                                    [{ values: [null, null, "285px"], properties: ["width"] }],
                                    mediaOptions.min,
                                );
                            }}
                        `,
                    }}
                    positionFunction={() => {
                        return {
                            position: "absolute",
                        };
                    }}
                    ref={popover}
                    insideRefs={[element]}
                    popoverTrigger={branchIndicator}
                >
                    <LoadingOverlay loading={isLoading} {...styles.loadingOverlay}>
                        <GridContainer {...styles.warehousesContainer}>
                            <GridItem {...styles.popoverTitleGridItem}>
                                <Typography {...styles.popoverTitle}>
                                    {translate("Current Sales Center")}
                                </Typography>
                            </GridItem>
                            <GridItem {...styles.fulfillmentMethodSelectionLabelGridItem}>
                                <Typography {...styles.fulfillmentMethodSelectionLabel}>
                                    {translate("How do you want your items?")}
                                </Typography>
                            </GridItem>
                            <GridItem width={12}>
                                <RadioGroup
                                    value={fulfillmentMethod}
                                    onChangeHandler={fulfillmentMethodChangeHandler}
                                    {...styles.fulfillmentMethodRadioGroup}
                                    data-test-selector="changeCustomerFulfillmentMethod"
                                >
                                    <StyledWrapper {...styles.fulfillmentMethodWrapper}>
                                        <StyledWrapper
                                            {...(fulfillmentMethod === FulfillmentMethod.PickUp
                                                ? styles.fulfillmentMethodRadioWrapperSelected
                                                : styles.fulfillmentMethodRadioWrapper)
                                            }
                                        >
                                            <Radio
                                                value={FulfillmentMethod.PickUp}
                                                {...styles.fulfillmentMethodRadio}
                                                data-test-selector="fulfillmentMethod_pickUp"
                                            >
                                            </Radio>
                                            <Icon
                                                {...(fulfillmentMethod === FulfillmentMethod.PickUp
                                                    ? styles.selectedPickupIcon
                                                    : styles.pickupIcon)
                                                }
                                            />
                                        </StyledWrapper>
                                        <Typography {...styles.fulfillmentMethodLabel}>
                                            {translate("Pickup")}
                                        </Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.separatorWrapper}>
                                        <Typography {...styles.separatorLabel}>
                                            {translate("or")}
                                        </Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.fulfillmentMethodWrapper}>
                                        <StyledWrapper
                                            {...(fulfillmentMethod === FulfillmentMethod.Ship
                                                ? styles.fulfillmentMethodRadioWrapperSelected
                                                : styles.fulfillmentMethodRadioWrapper)
                                            }
                                        >
                                            <Radio
                                                value={FulfillmentMethod.Ship}
                                                {...styles.fulfillmentMethodRadio}
                                                data-test-selector="fulfillmentMethod_ship"
                                            >
                                            </Radio>
                                            <Icon
                                                {...(fulfillmentMethod === FulfillmentMethod.Ship
                                                    ? styles.selectedShippingIcon
                                                    : styles.shippingIcon)
                                                }
                                            />
                                        </StyledWrapper>
                                        <Typography {...styles.fulfillmentMethodLabel}>
                                            {translate("Shipping")}
                                        </Typography>
                                    </StyledWrapper>
                                </RadioGroup>
                            </GridItem>
                            <GridItem {...styles.addressSelectorGridItem}>
                                <Clickable
                                    {...styles.addressSelectorClickable}
                                    onClick={handleOpenFindLocation}
                                >
                                    <Icon {...styles.addressSelectorPickupIcon} />
                                    <StyledWrapper {...styles.addressSelectorTextWrapper}>
                                        <Typography {...styles.addressSelectorTitleText}>
                                            {addressSelectorDisplay(FulfillmentMethod.PickUp)}
                                        </Typography>
                                        <Typography {...styles.addressSelectorAddressText}>{currentWarehouseAddress || ""}</Typography>
                                    </StyledWrapper>
                                    <Icon {...styles.addressSelectorChevronIcon}/>
                                </Clickable>
                            </GridItem>
                            <GridItem {...styles.addressSelectorGridItem}>
                                <Clickable
                                    {...styles.addressSelectorClickable}
                                    onClick={handleLinkToAddressPage}
                                >
                                    <Icon {...styles.addressSelectorShippingIcon} />
                                    <StyledWrapper {...styles.addressSelectorTextWrapper}>
                                        <Typography {...styles.addressSelectorTitleText}>
                                            {addressSelectorDisplay(FulfillmentMethod.Ship)}
                                        </Typography>
                                        <Typography {...styles.addressSelectorAddressText}>{displayedCurrentShipTo?.fullAddress || ""}</Typography>
                                    </StyledWrapper>
                                    <Icon {...styles.addressSelectorChevronIcon}/>
                                </Clickable>
                            </GridItem>
                        </GridContainer>
                    </LoadingOverlay>
                </Popover>
            </StyledWrapper>
            <FindLocationModal
                modalIsOpen={isFindLocationOpen}
                onWarehouseSelected={handleWarehouseSelected}
                onModalClose={handleFindLocationModalClose}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(BranchIndicator)),
    definition: {
        group: "Common",
        displayName: "Branch Indicator",
        fieldDefinitions: [],
    },
};

export default widgetModule;
